import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import SelectPretty from 'components/Input/SelectPretty'
import { vRequired } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import { find } from 'lodash'

export default class IncomingSmsForm extends Component {
  render() {
    const {
      handleSubmit,
      className,
      onSubmit,
      node,
      nodeInfo,
      numberOptions,
      showNumbersNewServiceModal,
      change,
    } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          This node will trigger whenever the selected number is called. Note, each number can only
          be attached to one flow.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <Field
          name="numberSid"
          options={numberOptions}
          component={SelectPretty}
          onChangeAlt={numberSid =>
            change('number', find(numberOptions, ['value', numberSid]).number)
          }
          label="Number"
          validate={[vRequired]}
        />
        <div className={cn(sText.descrip3, sText.center, sMarg.mb15)}>or</div>
        <Button onClick={() => showNumbersNewServiceModal()} color="tertiary" ghost>
          Create new number
        </Button>
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingSms/IncomingSmsForm.jsx